function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3119",
  "data-name": "Group 3119",
  transform: "translate(-572 -817)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_146",
  "data-name": "Ellipse 146",
  cx: 23,
  cy: 23,
  r: 23,
  transform: "translate(572 817)",
  fill: "#eeeff3"
}), /*#__PURE__*/React.createElement("path", {
  id: "file_present_FILL1_wght400_GRAD0_opsz48_1_",
  "data-name": "file_present_FILL1_wght400_GRAD0_opsz48 (1)",
  d: "M9.882,29.091A1.929,1.929,0,0,1,8,27.209V5.882a1.805,1.805,0,0,1,.565-1.317A1.805,1.805,0,0,1,9.882,4H20.42a1.875,1.875,0,0,1,1.349.565l5.74,5.74a1.875,1.875,0,0,1,.565,1.349V27.209a1.929,1.929,0,0,1-1.882,1.882ZM21.3,11.716h4.893L20.357,5.882v4.893a.912.912,0,0,0,.941.941ZM18.037,24.7a4.364,4.364,0,0,0,4.391-4.391V16.546a.593.593,0,0,0-.627-.627.629.629,0,0,0-.439.173.588.588,0,0,0-.188.455v3.764a3.056,3.056,0,0,1-.894,2.227,3.2,3.2,0,0,1-4.469,0,3.029,3.029,0,0,1-.91-2.227v-6.9a1.2,1.2,0,0,1,.361-.91,1.243,1.243,0,0,1,.894-.345,1.185,1.185,0,0,1,1.255,1.255v5.646a.643.643,0,0,0,.627.627.588.588,0,0,0,.455-.188.629.629,0,0,0,.173-.439V13.409a2.517,2.517,0,0,0-4.281-1.788,2.4,2.4,0,0,0-.737,1.788v6.9A4.39,4.39,0,0,0,18.037,24.7Z",
  transform: "translate(576.963 823.454)",
  fill: "#7d9ef1"
}));

var SvgAttachFileInsideCircle = function SvgAttachFileInsideCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttachFileInsideCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attach-file-inside-circle.0d14750a.svg";
export { ForwardRef as ReactComponent };